import { gql, useQuery } from '@apollo/client'

const GET_TICKETS = gql`
query getTickets($userId: Int4 = "") {
  tickets(where: {raisedBy: {_eq: $userId}}, order_by: {createdAt: Desc}) {
    assignedTo
    description
    id
    createdAt
    priority
    status
    title
    type
  }
}
`

const useFetchTicket = (userId) => {
  const { data, loading, error, refetch } = useQuery(GET_TICKETS, {
    context: {
      headers: {
        'x-hasura-role': 'learner'
      }
    },
    variables: { userId },
    skip: !userId
  })

  return { data: data?.tickets, loading, error, refetch }
}

export default useFetchTicket